"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSignOut = void 0;
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var user_1 = require("../user");
var useSignOut = function () {
    var router = (0, navigation_1.useRouter)();
    var lang = (0, next_intl_1.useLocale)();
    var setAuthorized = (0, user_1.useSetAuthorized)();
    var _a = (0, useMutation_1.useMutation)({
        successAction: function () {
            setAuthorized(false);
            window.dispatchEvent(new CustomEvent('authChange'));
            router.push("/".concat(lang));
        },
        clearKeys: [
            keys_1.USER,
            keys_1.BALANCE,
            keys_1.WITHDRAWAL_BALANCE,
            keys_1.USER_KYC,
            keys_1.MY_LEVEL_PROGRESS,
            keys_1.PAY_IN_PROFILE_METHODS,
            keys_1.BONUSES_BY_TYPE,
            keys_1.GET_RECENT_GAMES,
            keys_1.GET_FAVORITE_GAMES,
            keys_1.GET_DEPOSIT_LIMITS,
            keys_1.GET_LOSS_LIMITS,
            keys_1.GET_BET_LIMITS,
            keys_1.GET_COOL_OFF_LIMITS,
            keys_1.GET_SESSION_LIMITS,
        ],
        keysUpdate: [keys_1.TOURNAMENTS, keys_1.TOURNAMENTS_CURRENT],
        path: keys_1.SIGN_OUT,
    }), mutate = _a.mutate, isSubmitting = _a.isSubmitting, error = _a.error;
    return (0, react_1.useMemo)(function () { return ({
        signOut: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useSignOut = useSignOut;
